import React from 'react';
import '../../Dashboard.css'
export default function SubscriberHeader() {
  return (
    <div className="header-actions-container">
      {/* Search Bar */}
      <div className="search-bar">
        <span className="search-icon"></span>
        <input type="text" placeholder="Search" />
      </div>

      {/* Action Buttons */}
      <div className="action-buttons">
        <button className="btn-action">
          <span className="btn-icon cc-icon"></span> Make a payment
        </button>
        <button className="btn-action upgrade-service">
          <span className="btn-icon upgrade-icon"></span> Upgrade service
        </button>
        <button className="btn-notifications">
          <span className="btn-icon bell-icon"></span>
          {/* <span className="notification-dot"></span> */}
        </button>
      </div>
    </div>
  );
}
